export default {
  getapprovallist: "/approval/getapprovallist",//请假列表
  getapprovaldetail: "/approval/list/{applyId}",//请假详情
}



// WEBPACK FOOTER //
// ./src/api/config/leaveSituation.js